import React from 'react';
import Reveal from '../../../components/ui/Reveal';

const HistorySection = () => {
  return (
    <section className="py-12 lg:py-16 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 lg:px-6">
        <div className="text-center mb-8">
          <h2 className="text-2xl lg:text-3xl font-bold text-[#0D1C3D]">ประวัติความเป็นมาอำเภอเทิง</h2>
          <p className="text-muted-foreground text-base lg:text-lg mt-2">เรื่องราว ความเป็นมาของพื้นที่ และอัตลักษณ์ท้องถิ่น</p>
        </div>
        <Reveal y={18} duration={720}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start">
            <p className="text-foreground leading-8 text-[16px] bg-white rounded-xl p-6 shadow-government">
              อำเภอเทิงตั้งอยู่ทางตะวันออกของจังหวัดเชียงราย รายล้อมด้วยธรรมชาติภูเขาและสายน้ำ
              ผู้คนมีวิถีชีวิตที่เรียบง่าย มีวัฒนธรรมและประเพณีที่งดงาม สะท้อนผ่านงานเทศกาลและอาหารท้องถิ่น
              จุดเด่นคือทิวทัศน์ภูชี้ฟ้าและวัดพระธาตุจอมจ้อซึ่งเป็นที่เคารพนับถือของชุมชน
            </p>
            <div className="rounded-xl overflow-hidden shadow-government">
              <img src="/assets/images/bgnew.png" alt="ภูชี้ฟ้า" className="w-full h-72 object-cover" />
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default HistorySection;


